import * as React from 'react';

const BuyerProtectionShield32 = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 32 32", width: 32, height: 32, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#C9F0EE",
    d: "M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#007782",
    d: "M15.026 7.977c.45-.143.922-.253 1.375-.253s.926.11 1.375.253c1.53.486 5.78 1.272 5.77 3.384-.007 1.437-.019 3.976-.019 4.64 0 2.021-1.024 3.824-2.198 5.237-1.183 1.423-2.588 2.537-3.509 3.193a2.43 2.43 0 0 1-2.838 0c-.92-.656-2.326-1.77-3.509-3.193-1.173-1.413-2.198-3.215-2.198-5.236 0-.665-.012-3.204-.019-4.641-.01-2.112 4.24-2.898 5.77-3.384m4.886 5.836a.75.75 0 0 0-1.153-.96l-2.807 3.369-1.42-1.42a.75.75 0 0 0-1.06 1.061l2 2a.75.75 0 0 0 1.106-.05z"
  }
));
BuyerProtectionShield32.Size = 32;
BuyerProtectionShield32.Title = "BuyerProtectionShield";

export { BuyerProtectionShield32 as default };
